export default __webpack_public_path__ + "static/media/rbb_favicon.5af4d620.ico";